import React, { useEffect, useState } from 'react'
import { Newsletter } from 'cwp-components/Newsletter'
import { TopAuthorsSection } from './components/sections/TopAuthorsSection'
import { LatestArticlesSection } from './components/sections/LatestArticlesSection'
import { MostViewedArticlesSection } from './components/sections/MostViewedArticlesSection'
import { MostPublishedCategorySection } from './components/sections/MostPublishedCategorySection'
import { SectorsSection } from './components/sections/SectorsSection'
import { SearchByLawSection } from './components/sections/SearchByLawSection'
import { AllArticlesAndBlogs } from './components/sections/AllArticlesAndBlogs'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

const Articles = () => {
  const [articlesSelected, setArticlesSelected] = useState<boolean>(true)
  const {
    results,
    sortOption,
    setSortOption,
    searchValue,
    setSelectedType,
    setSelectedSector,
    updateSearchValue,
    loadMore,
    hasNext,
    loadArticles,
    mostViewed,
    loadMostViewed,
    isLoading,
    selectedSector,
  } = useArticleTemplate({ pageSize: 6 })

  useEffect(loadArticles, [loadArticles])
  useEffect(loadMostViewed, [loadMostViewed])

  return (
    <div className='flex flex-col gap-[80px] md:gap-[150px] lg:gap-[300px]'>
      <div
        className='flex 
        flex-col lg:flex-row 
        justify-center lg:justify-between
        items-center lg:items-start
        px-[16px] sm:px-[32px] md:px-[64px] lg:px-[100px] xl:px-[140px] 
        pt-[40px] md:pt-[60px] lg:pt-[100px] xl:pt-[180px]
        gap-[40px]
        bg-gradient-to-b from-[#B8E0DB]/50 to-white h-full'
      >
        <MostViewedArticlesSection nr={2} />

        <LatestArticlesSection nr={3} />
      </div>

      <div
        className='flex
        flex-col lg:flex-row 
        justify-center lg:justify-between 
        items-center lg:items-start 
        px-[25px] lg:px-[40px] xl:px-[80px] 2xl:px-[140px] 
        gap-[80px] lg:gap-[40px]'
      >
        <AllArticlesAndBlogs
          {...{
            updateSearchValue,
            sortOption,
            searchValue,
            mostViewed,
            results,
            hasNext,
            loadMore,
            setSelectedType,
            setSortOption,
            isLoading,
            articlesSelected,
            setArticlesSelected,
          }}
        />

        <div
          className='flex flex-col 
          text-center lg:text-left 
          flex-shrink lg:flex-shrink-0 lg:w-[417px] 
          gap-[120px]'
        >
          <TopAuthorsSection nr={2} />

          <SearchByLawSection />

          <SectorsSection
            articlesSelected={articlesSelected}
            selectSectorFilter={setSelectedSector}
            selectedSector={selectedSector}
          />
          <MostPublishedCategorySection nr={4} />
        </div>
      </div>

      <Newsletter />
    </div>
  )
}
export default Articles
